import React, { Component } from 'react';
import { MessageList } from './MessageList';
import { SendMessageForm } from './SendMessageForm';
import { ActionsMenu } from './ActionsMenu';
/*import Avatar from './../../img/avatar-1-32.png';*/
import MenuIcon from './../../img/menu-24.png';


export class Chat extends Component {
    static displayName = Chat.name;

    render() {

        return (
            <section className="chat-area">
                <div className="chat-area-in">
                    <Title
                        addContact={this.props.addContact}
                        deleteChat={this.props.deleteChat}
                        editContact={this.props.editContact}
                        thread={this.props.thread}
                        memberDetail={this.props.memberDetail}
                        user={this.props.user}
                        baseApi={this.props.baseApi}
                        parentAppBaseUrl={this.props.parentAppBaseUrl}
                        createInteractionThread={this.props.createInteractionThread}
                        isIframe={this.props.isIframe}
                    />

                    <MessageList
                        messageList={this.props.messageList}
                        isIframe={this.props.isIframe}
                    />
                    <SendMessageForm disabled={this.props.thread == null} sendMessage={this.props.sendMessage} />
                </div>
            </section>
        );
    }
}

export class Title extends Component {

    constructor(props) {
        super(props);

        this.state = {

        };
        
        this.showThreadList = this.showThreadList.bind(this);
    }
            
    showThreadList() {
        setTimeout(() => {
            const element = document.getElementById('thread-chat-list');
            element.classList.add('show-chat-list');
        }, 100);
    }

    showDashboard() {
        setTimeout(() => {
            let url = window.location.replace('Inbox', 'Dashboard');
            window.parent.location(url);
        }, 100);
    }

    render() {
        var contactNames = this.props.thread ? this.props.thread.InteractionContactNames : '';
        var cellphones = this.props.thread ? this.props.thread.InteractionContactCellPhones : '';

        return (
            <div className="chat-area-header">
                <div className="div_contact_menuIcon" onClick={() => this.showThreadList()}>
                    <a className="chat_menuIcon" title="Click to open the menu">
                        <div className="divMenuIcon">
                            <img src={MenuIcon} alt="" />
                        </div>
                    </a>
                </div>
                <div className="chat-list-item header-chat-list-item">
                    <div className="chat-list-item-header">
                        <div className="chat-list-item-name">
                            {contactNames}
                        </div>
                    </div>
                    <div className="chat-list-item-txt writing">{cellphones}
                    </div>
                </div>
                <div className="chat-area-header-action">
                    {this.props.isIframe ?
                        '' :
                        <ActionsMenu
                            thread={this.props.thread}
                            addContact={this.props.addContact}
                            deleteChat={this.props.deleteChat}
                            editContact={this.props.editContact}
                            memberDetail={this.props.memberDetail}
                        />
                    }
                </div>
            </div>
        );
    }
}
